module.exports = __webpack_public_path__ + "static/media/line.59fc2a0d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/images/line.jpeg
// module id = 556
// module chunks = 0